import AbstractChannel from './AbstractChannel'

export default class Flash extends AbstractChannel {

  readonly isParcsChannel: boolean = true

  name = 'flash'
  title = 'Flash'
  titleShort = 'Flash'
  color = '#c7c7c7'

}
